export const PUBLIC = 1;
export const PRIVATE_ALL_TARGETED_LISTS = 2;
export const PRIVATE_LIMITED_TARGETED_LISTS = 3;
